<template>
  <el-dialog
    title="选择您要想修改的状态"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
      直播状态: <el-select v-model="row.status">
        <el-option label="直播中" :value="20"></el-option>
        <el-option label="直播结束" :value="30"></el-option>
        <el-option label="已生成回放" :value="40"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateLesperiodStatus">确 定</el-button>
        <el-button @click="handleClose">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { updateLesperiodStatus } from '@/api/class/lesperiod'
export default {
  name: 'EditStatus',
  data () {
    return {
      dialogVisible: false,
      row: {status: ''}
    }
  },
  methods: {
    init(row) {
      this.row = row
      if (row.status === 10) row.status = ''
      this.dialogVisible = true
    },
    async updateLesperiodStatus() {
      if (!this.row.status) return
      const res = await updateLesperiodStatus({ id: this.row.id, status: this.row.status })
      this.$message.success('操作成功')
      this.handleClose()
      this.$parent.search()
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.editStatus {

}
</style>
